import template from './loansSignUpFormSimulation.html';
import controller from './loansSignUpFormSimulation.controller';
import './loansSignUpFormSimulation.scss';

let loansSignUpFormSimulationComponent = {
  restrict: 'E',
  bindings: {
    simulationWitness: '<',
    loan: '<',
    onSubmit: '&',
    simulation: '<',
    loanPurposes: '<',
    housingChange: '<',
    housingLoan: '<',
    isMobileApp: '<',
    initialCharges: '<',
    data: '<'
  },
  template,
  controller,
};

export default loansSignUpFormSimulationComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpFormSimulation/loansSignUpFormSimulation.component.js